import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { FlowDownstreamDatasourcesQueryVariables, FlowDownstreamDatasourcesQuery, DatasourcesDisplayGridRowDataFragment, FlowDownstreamDatasourcesFilteredByFlowOutputFieldQueryVariables, FlowDownstreamDatasourcesFilteredByFlowOutputFieldQuery, PublishedDatasourceSortOrder , FlowDownstreamDatasourcesFilteredByFlowOutputFieldDocument , FlowDownstreamDatasourcesDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import { DatasourcesDisplayGrid, DatasourcesDisplayGridRowData } from '../sharedDisplayGrid/DatasourcesDisplayGrid';
import { DatasourcesValidSortFields } from '../sorting/sortProviders/DatasourcesGridSortProvider';

type QueryVariables = FlowDownstreamDatasourcesQueryVariables;
type QueryResults = FlowDownstreamDatasourcesQuery;
type QueryResultListNode = DatasourcesDisplayGridRowDataFragment;
type GridRowData = DatasourcesDisplayGridRowData;

type QueryVariablesWithFilter = FlowDownstreamDatasourcesFilteredByFlowOutputFieldQueryVariables;
type QueryResultsWithFilter = FlowDownstreamDatasourcesFilteredByFlowOutputFieldQuery;
type QueryResultListNodeWithFilter = DatasourcesDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const flow = resultData && resultData.flows && resultData.flows[0];
  return flow ? flow.downstreamDatasourcesConnection : null;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const flow = resultData && resultData.flows && resultData.flows[0];
  const flowOutputFields = flow && flow.outputFieldsConnection && flow.outputFieldsConnection.nodes;
  const field = flowOutputFields && flowOutputFields[0];
  return field ? field.downstreamDatasourcesConnection : null;
}

function mapResultNode(node: QueryResultListNode): GridRowData {
  return {
    id: node.id,
    name: node.name,
    description: node.description || '',
    owner: node.owner,
    workbookCount: node.downstreamWorkbooksConnection ? node.downstreamWorkbooksConnection.totalCount : null,
    vizportalUrlId: node.vizportalUrlId,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    extractLastUpdateTime: node.extractLastUpdateTime || null,
    containerName: node.containerName,
    containerType: node.containerType,
    projectVizportalUrlId: node.projectVizportalUrlId,
    hasExtracts: !!node.hasExtracts,
    isCertified: node.isCertified,
    certifier: node.certifier,
    certificationNote: node.certificationNote || ''
  };
}

export type FlowDownstreamDatasourcesQueryGridProps =
  GridSortProps<DatasourcesValidSortFields> & {
    readonly flowVizportalUrlId: string;
    readonly filteredFlowOutputFieldId: string | null;
    readonly rowCount: number | null;
  };

export function FlowDownstreamDatasourcesQueryGrid(props: FlowDownstreamDatasourcesQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamDatasourcesLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredDatasourcesLineageGridMessage();

  return (
    props.filteredFlowOutputFieldId ? (
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNodeWithFilter, GridRowData>
        queryGql={FlowDownstreamDatasourcesFilteredByFlowOutputFieldDocument}
        partialQueryVariables={{
          flowVizportalUrlId: props.flowVizportalUrlId,
          selectedFlowOutputFieldId: props.filteredFlowOutputFieldId,
          orderBy: props.orderBy as PublishedDatasourceSortOrder,
        }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={mapResultNode}
      >
        {({ rowStore }) => <DatasourcesDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    ) : (
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={FlowDownstreamDatasourcesDocument}
        partialQueryVariables={{
          flowVizportalUrlId: props.flowVizportalUrlId,
          orderBy: props.orderBy as PublishedDatasourceSortOrder,
        }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={mapResultNode}
      >
        {({ rowStore }) => <DatasourcesDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    )
  )
}
